import React from 'react';

const DefaultLayout = ({ children }) => {
  return children();
};

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.js